/**
 * Kimble identity, read-only. A plain `<td>` of text with no form control
 * and no `onChange` prop.
 */

import type { ReactNode } from 'react';

interface IdentityCellProps {
  text: string | null | undefined;
  mono?: boolean;
  clip?: boolean;
  sticky?: boolean;
  /** f11.6: a validation warning on this cell (e.g. an unmapped Resource BU). */
  warning?: string;
  children?: ReactNode;
}

export function IdentityCell({ text, mono = false, clip = false, sticky = false, warning, children }: IdentityCellProps) {
  const classes = ['col-ro', mono && 'mono', clip && 'fg-clip', sticky && 'sticky-l fg-element', warning && 'cell-warning']
    .filter(Boolean)
    .join(' ');
  return (
    <td className={classes} title={warning ?? (clip && text ? text : undefined)}>
      {text ?? '—'}
      {children}
    </td>
  );
}
